<template>
  <div class="feedback">
    <div class="feedback-search">
      <van-search
        v-model="value"
        show-action
        placeholder="请输入主题关键词"
        @search="onSearch"
      >
        <template #action>
          <div class="search-button" @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="feedback-tabs">
      <!-- <div class="Badge1">55</div>
      <div class="Badge2">55</div>
      <div class="Badge3">55</div>
      <div class="Badge4">55</div>
      <div class="Badge5">55</div> -->
      <div class="feedback-tabs-item-top">
        <div class="feedback-tabs-item-top-conten">
          <span>问题类型</span>
          <van-dropdown-menu active-color="#EA4949">
            <van-dropdown-item
              v-model="type"
              :options="optionsType"
              @change="dropdownChange"
            />
          </van-dropdown-menu>
        </div>
      </div>
      <van-tabs
        v-model="active"
        line-width="18"
        line-height="2"
        animated
        :sticky="true"
        offset-top="70"
        @click="tabschange"
      >
        <van-tab
          :title="item"
          v-for="(item, index) in tabTitle"
          :key="index"
          class="tab"
        >
          <div class="feedback-tabs-item">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                class="feedback-tabs-item-conten"
                v-for="(item, index) in listData"
                :key="index"
                @click="goDetails(dataTypeList[item.data_type], item.id)"
              >
                <div class="feedback-tabs-item-conten-top">
                  <div class="feedback-tabs-item-conten-top-no">
                    <div class="feedback-tabs-item-conten-top-no-left">
                      问题ID：<span>{{ item.id }}</span>
                    </div>
                    <div
                      class="feedback-tabs-item-conten-top-no-right"
                      :style="{
                        color:
                          item.status == 1
                            ? '#EA4949'
                            : item.status == 2
                            ? '#EA4949'
                            : item.status == 3
                            ? '#26CC71'
                            : '#F66D10',
                      }"
                    >
                      {{
                        item.status == 1
                          ? "已受理"
                          : item.status == 2
                          ? "处理中"
                          : item.status == 3
                          ? "已办结"
                          : "已评价"
                      }}
                    </div>
                  </div>
                  <div class="feedback-tabs-item-conten-zt">
                    主题：<span>{{ item.title }}</span>
                  </div>
                  <div class="feedback-tabs-item-conten-fs">
                    反馈方式：<span>{{
                      item.feedback_type == 1 ? "实名" : "匿名"
                    }}</span>
                  </div>
                  <div class="feedback-tabs-item-conten-fs">
                    问题类型：<span>{{ dataTypeList[item.data_type] }}</span>
                  </div>
                </div>
                <div class="feedback-tabs-item-conten-fl"></div>
                <div class="feedback-tabs-item-conten-bottom">
                  <div class="feedback-tabs-item-conten-bottom-left">
                    {{ item.create_time_text }}
                  </div>
                  <img
                    class="feedback-tabs-item-conten-bottom-right"
                    src="@/assets/img/＞_拷贝_7 (1).png"
                    alt=""
                  />
                </div>
              </div>
            </van-list>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { $get_feedback_list } from "@/api";
export default {
  data() {
    return {
      value: "", // 搜索内容
      active: 0, // tabs 激活标签对应的索引值
      state: "", // 状态
      pageNumber: 10, // 每页显示的数据数量
      current: 1, // 分页器的当前页数
      // 状态的下拉菜单数据
      optionsState: [
        { text: "全部", value: "" },
        { text: "已受理", value: "1" },
        { text: "处理中", value: "2" },
        { text: "已办结", value: "3" },
        { text: "已评价", value: "4" },
      ],
      type: "", // 问题类型
      // 问题类型的下拉菜单数据
      optionsType: [
        { text: "全部", value: "" },
        { text: "合理化建议", value: "1" },
        { text: "投诉举报", value: "2" },
        { text: "表彰表扬", value: "3" },
      ],
      total: 150, // 数据总数
      listData: [], // 列表数据
      tabTitle: ["全部", "已受理", "处理中", "已办结", "已评价"],
      loading: false, // 控制load事件是否触发
      finished: false, // 判断数据是否已全部加载完毕
      dataTypeList: {
        1: "合理化建议",
        2: "投诉举报",
        3: "表彰表扬",
      },
    };
  },
  mounted() {
    this.onLoad();
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          if (document.documentElement.clientWidth > 767) {
            this.$router.push({ name: "feedback", query: { index: 0 } });
          }
        });
      })();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    // tabs 导航栏切换
    tabschange(name) {
      if (name) {
        this.state = name;
      } else {
        this.state = "";
      }
      this.listData = [];
      this.current = 1;
      this.onLoad();
    },
    // 下拉菜单切换
    dropdownChange() {
      this.listData = [];
      this.current = 1;
      this.onLoad();
    },
    // 进行搜索
    onSearch() {
      this.listData = [];
      this.current = 1;
      this.onLoad();
    },
    // 组件滚动到底部时，会触发 load 事件 获取数据
    async onLoad() {
      try {
        this.loading = true;
        let params = {
          page: this.current,
          rows: this.pageNumber,
          status: this.state,
          data_type: this.type,
          key_word: this.value,
          order_by: "1",
        };
        let res = await $get_feedback_list(params);
        this.listData.push(...res.data.data);
        this.total = res.data.total;
        this.pageNumber = res.data.per_page;
        this.current++;
        this.loading = false;
        if (this.listData.length >= this.total) {
          this.finished = true;
        }
      } catch (error) {}
    },
    // 查看详情
    goDetails(name, id) {
      let names = {
        合理化建议: "suggestionDetail",
        投诉举报: "complaintDetail",
        表彰表扬: "commendDetail",
      };
      this.$router.push({
        name: names[name],
        query: { id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.feedback {
  min-height: 100vh;
  background: #f5f5f5;
  position: relative;

  .feedback-search {
    position: fixed;
    top: 0;
    background: #fff;
    display: flex;
    justify-content: center;
    padding-top: 21px;
    padding-bottom: 20px;
    width: 100%;
    z-index: 999;

    /deep/.van-search {
      padding: 0;
      width: 90%;
    }

    /deep/.van-search__action {
      padding: 0;
    }

    .search-button {
      width: 57px;
      height: 32px;
      background: #ea4949;
      border-radius: 0px 5px 5px 0px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .feedback-tabs {
    padding-top: 70px;
    position: relative;

    /deep/.van-tab {
      padding: 0;
    }

    /deep/.van-tabs--line .van-tabs__wrap {
      height: 35px;
    }

    /deep/.van-tabs__line {
      bottom: 15px;
    }

    /deep/.van-tab__pane,
    .van-tab__pane-wrapper {
      background: #f5f5f5;
    }

    /deep/.van-tabs__content {
      margin-top: 15px;
    }

    .feedback-tabs-item-top {
      position: absolute;
      top: 120px;
      left: 6%;
      width: 90%;
      margin: 0 auto;
      display: flex;
      padding-bottom: 12px;
      z-index: 2;

      .feedback-tabs-item-top-conten {
        display: flex;
        align-items: center;

        /deep/.van-dropdown-menu {
          width: 0;
          height: 0;

          .van-dropdown-menu__bar {
            height: 100%;
          }

          .van-dropdown-item--down {
            top: 150px !important;
            height: 100vh;
          }

          .van-dropdown-item__content {
            max-height: 100%;
          }

          .van-dropdown-menu__title::after {
            border-color: transparent transparent #333333 #333333;
            margin-top: -9px;
            width: 13px;
            height: 12px;
            opacity: 1;
            right: -10px;
          }

          .van-dropdown-menu__title--down::after {
            margin-top: -3px;
          }
        }

        span {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          margin-right: 8px;
        }

        img {
          width: 13px;
          height: 8px;
        }
      }
    }

    .Badge1 {
      width: 16px;
      height: 16px;
      background: #ea4949;
      border-radius: 50%;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0%;
      left: 14%;
      z-index: 99;
    }

    .Badge2 {
      width: 16px;
      height: 16px;
      background: #ea4949;
      border-radius: 50%;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0%;
      left: 36%;
      z-index: 99;
    }

    .Badge3 {
      width: 16px;
      height: 16px;
      background: #ea4949;
      border-radius: 50%;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0%;
      left: 56%;
      z-index: 99;
    }

    .Badge4 {
      width: 16px;
      height: 16px;
      background: #ea4949;
      border-radius: 50%;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0%;
      left: 76%;
      z-index: 99;
    }

    .Badge5 {
      width: 16px;
      height: 16px;
      background: #ea4949;
      border-radius: 50%;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0%;
      left: 95%;
      z-index: 99;
    }

    .tab {
      position: relative;

      .feedback-tabs-item {
        min-height: 100vh;
        margin-top: 30px;

        .feedback-tabs-item-conten {
          width: 90%;
          margin: 0 auto;
          background: #fff;
          padding: 15px 0;
          margin-bottom: 8px;

          .feedback-tabs-item-conten-top {
            margin: 0 10px;

            .feedback-tabs-item-conten-top-no {
              margin-bottom: 22px;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .feedback-tabs-item-conten-top-no-left {
                display: flex;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666666;

                span {
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  word-break: break-all;
                  text-overflow: ellipsis;
                  // width: 150px;
                  // display: -webkit-box;
                  // -webkit-box-orient: vertical;
                  // -webkit-line-clamp: 1;
                  // overflow: hidden;
                }
              }

              .feedback-tabs-item-conten-top-no-right {
                min-width: 100px;
                flex: 1;
                text-align: right;
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #ea4949;
              }
            }

            .feedback-tabs-item-conten-zt {
              display: flex;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #666666;
              margin-bottom: 8px;

              span {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666666;
                width: 155px;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }
            }

            .feedback-tabs-item-conten-fs {
              margin-bottom: 8px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #666666;
            }
          }

          .feedback-tabs-item-conten-fl {
            height: 1px;
            background: #e0e0e0;
            margin-bottom: 18px;
          }

          .feedback-tabs-item-conten-bottom {
            margin: 0 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .feedback-tabs-item-conten-bottom-left {
              font-size: 15px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
            }

            .feedback-tabs-item-conten-bottom-right {
              width: 8px;
              height: 13px;
            }
          }
        }
      }
    }
  }
}
</style>